module.exports = __webpack_public_path__ + "static/winning-1768de81fa3eef9da9ce4aedc029bc69.mp3";